export default "__VITE_ASSET__45ccde67__"